export const navLinksdata = [
  {
    _id: 1001,
    title: "Home",
    link: "home",
  },
  {
    _id: 1002,
    title: "Career",
    link: "career",
  },
  {
    _id: 1003,
    title: "Skills",
    link: "skills",
  },
  {
    _id: 1004,
    title: "Projects",
    link: "projects",
  },
  {
    _id: 1005,
    title: "Contributions",
    link: "contributions",
  },
  {
    _id: 1006,
    title: "Blog",
    link: "blog",
  },
  {
    _id: 1007,
    title: "Contact",
    link: "contact",
  },
];
